



import RegisterMobile from '../sections/register/template_02';






import SECTION_FOOTER_BANNER from
'../dynamic_section/dynamic_2/template_01';



import "./style.css";


const RegisterPage = ()=>{
  
return (
  <div id="registerPage" class="page ">
  
  

  
  <RegisterMobile desktopTitleToggle={ true }
    mobileTitleToggle={ true } birthdayReminder={ true } />
  
  
  
  

  
  < SECTION_FOOTER_BANNER desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `footer_banner` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
  
  

  
</div>
)
}

export default RegisterPage;